<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <!-- <download-template-button title="Download Template" @download="downloadTemplate()"></download-template-button> -->
            <!-- <upload-button @upload="openUploadDialog()"></upload-button> -->
            <refresh-button @refresh="refreshTable()"></refresh-button>
            <!-- <add-button @add="openAddDialog"></add-button> -->
            <!-- Dialog for Add, View Edit  -->
            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="dialogStatus"
              @saveDialog="saveDialog"
              @closeDialog="closeDialog"
              :loading="dialogLoading"
            >
              <v-container grid-list-xs>
                <v-layout justify-center>
                  <v-flex md6>
                    <!-- Insert View Dialog Content BELOW-->
                    <details-container
                      ref="detailsRef"
                      :data="viewData"
                      :readonly="dialogType === 'view'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </action-dialog>

            <action-dialog
              :type="dialogType"
              :title="title"
              :dialog="uploadDialog"
              @saveDialog="saveDialog"
              @closeDialog="closeUploadDialog"
              :disableSave="uploadItems.length<1"
            >
              <v-container class="ma-0 pa-0" fluid>
                <v-layout justify-center>
                  <upload-csv ref="uploadRef" @selectFile="uploadCsvLoad"></upload-csv>
                </v-layout>

                <v-layout v-if="uploadLoading" justify-center align-center class="mt-5">
                  <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
                </v-layout>
                <v-layout justify-center v-if="uploadItems.length > 0 && !uploadLoading">
                  <jti-expansion-panel panelName="Access Card List">
                    <div class="scrolling-upload">
                      <v-data-table
                        :headers="uploadHeaders"
                        :items="uploadItems"
                        hide-actions
                        disable-initial-sort
                      >
                        <template slot="items" slot-scope="props">
                          <td class="text-xs-center">{{ props.index + 1}}</td>
                          <td class="text-xs-left">{{ props.item.embedded_id }}</td>
                          <td class="text-xs-left text-no-wrap">
                            <v-btn v-if="props.item.status === 0" flat icon color="pink">
                              <v-icon>close</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.status === 1" flat icon color="green">
                              <v-icon>check</v-icon>
                            </v-btn>
                            {{
                            props.item.status === 0 ? props.item.message :
                            props.item.status === 1 ? "Successfully Added" : "" }}
                          </td>
                        </template>
                      </v-data-table>
                    </div>
                  </jti-expansion-panel>
                </v-layout>
              </v-container>
            </action-dialog>

            <delete-dialog
              :title="title"
              :type="deleteType"
              :deleteDialog="deleteDialog"
              @saveDeleteDialog="saveDeleteDialog"
              @closeDeleteDialog="closeDeleteDialog"
              :loading="confirmLoading"
            ></delete-dialog>
            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="
              dialogType === 'edit' ? saveEditDialog() : 
              dialogType === 'add' ? saveAddDialog() : ''
              dialogType === 'upload' ? saveUploadDialog() : ''"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>

            <message-dialog
              :dialog="messageDialog"
              :title="messageTitle"
              :message="messageText"
              @save="dialogType==='remove' ? saveRemoveDialog() : ''"
              @close="closeMessageDialog"
              :loading="messageLoading"
            ></message-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <v-btn flat @click="openFilterExpansion">
                  <v-icon
                    class="mr-3"
                  >{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >Row per Page:</p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="this.items.length < 10 ? true : false"
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >{{ itemFrom + " -" + itemTo + " of " }} {{ totalItems }}</p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4></v-flex>
          </filter-panel>

          <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon
                    small
                    v-if="header.sortable"
                  >{{ header.sortNum === 1 ? "arrow_downward" : "arrow_upward"}}</v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">{{ props.index + queryParams.offset + 1}}</td>
              <td class="text-xs-left">{{ props.item.embedded_id }}</td>
              <td
                class="text-xs-left text-uppercase"
              >{{ props.item.is_assigned ? "Assigned" : "Unassigned" }}</td>
              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <!-- <edit-button @edit="openEditDialog(props.item)"></edit-button> -->
                <delete-button
                  v-if="$moduleAccess('delete_accesscard')"
                  @delete="openRemoveDialog(props.item)"
                ></delete-button>
                <!-- <remove-button @remove="openRemoveDialog(props.item)"></remove-button> -->
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Services from "@/services/CompanyServices";
import DetailsContainer from "@/components/details_container/AccessCardDetailsContainer";
import UploadCsv from "@/components/UploadCSV";
var jsonexport = require("jsonexport");

export default {
  components: {
    DetailsContainer,
    UploadCsv
  },
  data() {
    return {
      openFilter: false,
      title: "Access Card",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Embedded ID",
          align: "left",
          value: "embedded_id",
          sortable: true
        },
        {
          text: "Employee",
          align: "left",
          value: "is_assigned",
          sortable: true
        },
        {
          text: "Action",
          align: "center",
          sortable: false
        }
      ],
      uploadItems: [],
      uploadHeaders: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Embedded ID",
          align: "left",
          value: "embedded_id",
          sortable: false
        },
        {
          text: " Remarks",
          align: "left",
          value: "",
          sortable: false
        }
      ],
      items: [],
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
        order: "",
        desc: false,
        company_id: this.$store.state.company.id
      },
      dialogType: "",
      dialogStatus: false,
      uploadDialog: false,
      openConfirmDialog: false,
      viewData: {},

      deleteDialog: false,
      deleteTitle: "",
      deleteType: "",

      confirmLoading: false,
      dialogLoading: false,

      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 }
      ],
      uploadLoading: false,
      messageDialog: false,
      messageTitle: "",
      messageText: "",
      messageLoading: false
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      }
    }
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getAccessCards(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getAccessCard(id);
        data = await response.data;
        data.embedded_id = data.embedded_id ? data.embedded_id : "";
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      return data;
    },

    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    itemNumber(data) {
      return data + this.queryParams.offset + 1;
    },
    async openAddDialog() {
      this.dialogLoading = true;

      this.dialogType = "add";
      this.dialogStatus = true;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openEditDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "edit";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);
      // let test = JSON.parse(this.viewData.phone_no);
      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    async openRemoveDialog(data) {
      this.messageDialog = true;
      this.messageTitle = "Remove " + this.title;
      this.messageText = `Are you sure you want to Remove this ${this.title}?`;
      this.dialogType = "remove";

      this.viewData = data;
    },
    async openDeleteDialog(data) {
      this.deleteDialog = true;
      this.deleteType = "single";
      this.viewData.id = data.id;
    },
    async openUploadDialog() {
      this.dialogLoading = true;
      this.title = "Access Card(s)";

      this.dialogType = "upload";
      this.uploadDialog = true;

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    saveDialog() {
      // Condition Form Required Form Validation
      if (this.$refs.detailsRef.validateForm()) {
        this.openConfirmDialog = true;
      }
      if (this.dialogType === "upload") this.openConfirmDialog = true;
    },
    saveUpDialog() {
      // Condition Form Required Form Validation
      this.openConfirmDialog = true;
    },
    async saveAddDialog() {
      this.confirmLoading = true;
      const data = this.$refs.detailsRef.computedData,
        body = {
          embedded_id: data.embedded_id,
          company_id: this.$store.state.company.id
        };
      try {
        const response = await Services.addAccessCard(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Access Card has been added!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 422) {
            if (error.response.data.column === "embedded_id") {
              this.$infoBar({
                type: "error",
                text: `Embedded ID already exist!`
              });
            } else {
              this.$infoBar({
                type: "error",
                text: `${this.$capitalizeFirstLetter(
                  error.response.data.column
                )} already exist!`
              });
            }
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveUploadDialog() {
      this.confirmLoading = true;

      const body = this.uploadItems.map(item => {
        return {
          embedded_id: item.embedded_id
        };
      });

      try {
        const response = await Services.uploadAccessCards({
          access_cards: body,
          company_id: this.$store.state.company.id
        });

        if (response.status === 201 || response.status === 204) {
          await this.getData();
          if (response.data.failed_count === 0) {
            this.closeUploadDialog();
            this.$infoBar({
              type: "success",
              text: "Access Cards has been imported!"
            });
          } else {
            this.uploadItems = await response.data.data;
            this.closeConfirmDialog();
            this.$infoBar({
              type: response.data.success_count === 0 ? "error" : "success",
              text: `${response.data.success_count} Success, ${response.data.failed_count} Failed.`
            });
          }
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error1) {
        if (!error1.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }

      this.confirmLoading = await false;
    },
    async saveEditDialog() {
      this.confirmLoading = true;

      const data = this.$refs.detailsRef.computedData,
        body = {
          id: data.id,
          embedded_id: data.embedded_id
        };
      try {
        const response = await Services.editAccessCard(body);

        if (response.status === 201 || response.status === 204) {
          this.closeDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Access Card has been updated!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        this.closeConfirmDialog();
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else {
          if (error.response.status === 422) {
            if (error.response.data.column === "embedded_id") {
              this.$infoBar({
                type: "error",
                text: `Embedded ID already exist!`
              });
            } else {
              this.$infoBar({
                type: "error",
                text: `${this.$capitalizeFirstLetter(
                  error.response.data.column
                )} already exist!`
              });
            }
          }
        }
      }
      this.confirmLoading = await false;
    },
    async saveDeleteDialog() {
      this.confirmLoading = true;

      try {
        const response = await Services.deleteAccessCard(this.viewData.id);
        if (response.status === 200 || response.status === 201) {
          this.closeDeleteDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Access Card has been deleted!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.confirmLoading = false;
    },
    async saveRemoveDialog() {
      this.messageLoading = true;

      try {
        const response = await Services.deleteAccessCard(this.viewData.id);

        if (response.status === 200 || response.status === 201) {
          this.closeMessageDialog();
          await this.getData();

          this.$infoBar({
            type: "success",
            text: "Accesss Card has been removed!"
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!"
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        } else if (error.response.status == 503) {
          this.$infoBar({
            type: "error",
            text: "Access card is assigned to employee."
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "No network or server connection"
          });
        }
      }
      this.messageLoading = false;
    },
    async closeDialog() {
      this.viewData = {};
      if (this.dialogLoading === false) {
        this.$refs.detailsRef.clear();
      }

      this.closeConfirmDialog();
      this.dialogType = "";
      this.dialogStatus = false;
    },
    async closeUploadDialog() {
      this.uploadItems = [];
      this.closeConfirmDialog();
      this.dialogType = "";
      this.uploadDialog = false;
    },
    async closeMessageDialog() {
      this.messageDialog = false;
      this.viewData = {};
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
    },
    async closeDeleteDialog() {
      this.deleteDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },
    refreshTable() {
      this.$refs.searchRef.clear();
      this.getData();
    },
    async downloadTemplate() {
      let rename = ["EMBEDDED ID"];

      var values = [];
      for (let r = 0; r < rename.length; r++) {
        values.push("");
      }
      var object = Object.assign({}, values);
      var data = [];
      data.push(object);

      this.downloadCsv(data, rename);
    },
    async downloadCsv(values, rename) {
      var filename = "accesscard_template.csv";
      jsonexport(values, { rename }, function(err, CSV) {
        if (err) return console.log(err);
        var data, link;
        var csv = CSV;
        if (csv == null) return;
        if (!csv.match(/^data:text\/csv/i)) {
          csv = "data:text/csv;charset=utf-8," + csv;
        }
        data = encodeURI(csv);
        link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", filename);
        link.click();
      });
    },
    async uploadCsvLoad(data) {
      this.uploadLoading = true;

      await this.uploadCsv(data);

      setTimeout(() => {
        this.uploadLoading = false;
      }, 600);
    },
    async uploadCsv(data) {
      var strDelimiter = strDelimiter || ",";
      var objPattern = new RegExp(
        "(\\" +
          strDelimiter +
          "|\\r?\\n|\\r|^)" +
          '(?:"([^"]*(?:""[^"]*)*)"|' +
          '([^"\\' +
          strDelimiter +
          "\\r\\n]*))",
        "gi"
      );
      const arrData = [[]];
      var arrMatches = null;
      var strMatchedValue = "";
      if (data !== "") {
        while ((arrMatches = objPattern.exec(data))) {
          var strMatchedDelimiter = arrMatches[1];
          if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
          ) {
            arrData.push([]);
          }
          if (arrMatches[2]) {
            strMatchedValue = arrMatches[2].replace(new RegExp('""', "g"), '"');
          } else {
            strMatchedValue = arrMatches[3];
          }
          arrData[arrData.length - 1].push(strMatchedValue);
        }
      }

      let heads = ["embedded_id"];

      let headObject = Object.assign({}, heads);

      var array = arrData;
      var len = array.length - 1;

      var objArray = [];
      for (var i = 1; i < len; i++) {
        objArray[i - 1] = {};
        var header = [];
        header.push(headObject);

        for (var e = 1; e < len; e++) {
          objArray[e - 1] = {};
          for (var k = 0; k < array[0].length && k < array[e].length; k++) {
            var key = header[0][k];
            objArray[e - 1][key] = array[e][k];
          }
          for (var l = 0; l < array[0].length && l < array[e].length; l++) {
            var key1 = header[0][l];
            objArray[e - 1][key1] = array[e][l];
          }
        }
      }
      var json = JSON.stringify(objArray);
      let str = json.replace(/},/g, "},\r\n");
      if (array[0].length !== heads.length) {
        this.disableSaveUpload = true;
        this.uploadItems = [];
        this.$infoBar({
          type: "error",
          text: "Column not matched!"
        });
      } else {
        this.disabledSave = false;
        let uploads = JSON.parse(str);

        const uploadItems = [];
        if (uploads.length > 0) {
          for (let u = 0, item = uploads; u < item.length; u++) {
            let upItem = {
              embedded_id: item[u].embedded_id
            };
            uploadItems.push(upItem);
          }
          this.uploadItems = await uploadItems;
        } else {
          this.uploadItems = [];
          this.$infoBar({
            type: "error",
            text: "No data on CSV file"
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  width: 400px;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
